import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import Utils from 'src/app/utils';

import timezones from 'timezones-list';

import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-monitor-edit',
  templateUrl: './monitor-edit.component.html',
  styleUrls: ['./monitor-edit.component.scss']
})
export class MonitorEditComponent implements OnInit {

  monitor: any;
  id?: number;

  formGroup = new FormGroup({
    name: new FormControl('',[
      Validators.required,
    ]),
    email: new FormControl('',[
      Validators.email,
      Validators.required,
    ]),
    phone: new FormControl('',[
      this.cellConditionalRequiredValidator
    ]),
    phone2: new FormControl('',[
      this.callConditionalRequiredValidator
    ]),
    country: new FormControl(null,[]
    ),
    timezone: new FormControl('',[]
    ),
    use_email : new FormControl(false,[]),
    use_phone : new FormControl(false,[]),
    use_sms : new FormControl(false,[]),
    use_whatsapp: new FormControl(false,[]),
    admin : new FormControl(false,[]),
    privacy : new FormControl(false,[]),
    fa2: new FormControl(false,[])
  })

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  passFormGroup = new FormGroup({
    password : new FormControl('',[Validators.required,Validators.minLength(8)]),
  })

  passSubmitted = false;

  get pf(): { [key: string]: AbstractControl } {
    return this.passFormGroup.controls;
  }

  teamsUrlGroup = new FormGroup({
    teams_webhook_url : new FormControl('',[])
  })

  teamsUrlSubmitted = false;
  teams_error = false;

  get tf(): { [key: string]: AbstractControl } {
    return this.teamsUrlGroup.controls;
  }

  countryListArray = Utils.getCountries();
  timezoneListArray = timezones;

  yesno = [{val:true,name:"Yes"},{val:false,name:"No"}]

  password_error = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.id = +this.route.snapshot.params['id'];

    //console.log('id',this.id);

    
    if(this.okService.settings.arc_on){
      this.formGroup.setControl('phone',new FormControl('',[Validators.required]))
    }

    this.getMonitor();

    //console.log(this.passFormGroup);

    this.formGroup.get('use_sms')?.valueChanges
    .subscribe(value => {
      this.formGroup.get('phone')?.updateValueAndValidity();
    });

    this.formGroup.get('use_phone')?.valueChanges
    .subscribe(value => {
      this.formGroup.get('phone2')?.updateValueAndValidity();
    });

    this.formGroup.get('use_whatsapp')?.valueChanges
    .subscribe(value => {
      this.formGroup.get('phone')?.updateValueAndValidity();
    });

    if(!this.okService.isAdmin()){
      
      this.formGroup.controls['name'].disable();
      this.formGroup.controls['email'].disable();
      this.formGroup.controls['country'].disable();
      this.formGroup.controls['timezone'].disable();
      this.formGroup.controls['use_email'].disable();
      this.formGroup.controls['use_phone'].disable();
      this.formGroup.controls['use_sms'].disable();
      this.formGroup.controls['use_whatsapp'].disable();
      this.formGroup.controls['admin'].disable();
      this.formGroup.controls['privacy'].disable();
      this.formGroup.controls['fa2'].disable();

      if(!this.okService.hasMonitorAccess('monitors','update')){
        this.formGroup.controls['phone'].disable();
        this.formGroup.controls['phone2'].disable();
      }

    }

  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();
    if(this.okService.settings.fa2){
      this.formGroup.get('phone')?.setValidators(Validators.required);
    }
  }

  getMonitor(){

    this.okService.get("monitors/"+this.id,[])
    .subscribe((data) => {

      this.monitor = data.body;

      //console.log(this.monitor);

      this.setForm();

    });
  }

  setForm(){
    this.formGroup.setValue({
      name: this.monitor.name,
      phone: this.monitor.phone,
      phone2: this.monitor.phone2,
      email: this.monitor.email,
      country: this.monitor.country,
      timezone: this.monitor.timezone,
      use_email : _.includes(this.monitor.contact,"Email"),
      use_phone : _.includes(this.monitor.contact,"Phonecall"),
      use_sms : _.includes(this.monitor.contact,"Sms"),
      use_whatsapp : this.okService.hasFeature('whatsapp') && _.includes(this.monitor.contact,"WhatsApp"),
      admin: this.monitor.admin,
      privacy: this.monitor.privacy,
      fa2: this.monitor.fa2
    });

    this.passFormGroup.setValue({
      password: '',
    });

    this.teamsUrlGroup.setValue({
      teams_webhook_url: this.monitor.teams_webhook_url,
    });

  }

  submitForm(){
    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values:any = this.formGroup.value

        //console.log(values);


        // Update the contact values for the monitor
        if(this.okService.isAdmin()){
          let contact = [];
          if(!!values.use_email && values.use_email!='false'){ contact.push("Email"); }
          if(!!values.use_phone && values.use_phone!='false'){ contact.push("Phonecall"); }
          if(!!values.use_sms && values.use_sms!='false'){ contact.push("Sms"); }
          if(this.okService.hasFeature('whatsapp') && !!values.use_whatsapp && values.use_whatsapp!='false'){ contact.push("WhatsApp"); }
  
          values.contact = contact;
        }



        this.okService.put("monitors/"+this.id,values)
        .subscribe({
          next: (data) => {

            this.monitor = data.body;

            //console.log("monitor",this.monitor);

            this.setForm();


            if(this.okService.session.id == this.id){
              this.okService.refreshUser();
            }


            this.okService.setAlert(this.transloco.translate("The monitor has been updated"),"success");
          },
          error: (e) => {

            //console.log("error",e);

            if(Array.isArray(e)){
              let self = this;
              // Use of _.forEach() method
              _.forEach(e, function(error:any) {
                //console.log(error);
                self.formGroup.get(error.field)?.setErrors({ invalid: error.message });
              });
            }else{
              this.okService.setAlert(e,"warning")
            }


          },
          complete: () => {
            //console.info('complete');
          }
      });


      }

    return false;
  }


  submitPassForm(){
    this.passSubmitted = true;
    this.password_error = false;
    if (
      this.passFormGroup.valid
      ) {
        let values = this.passFormGroup.value

        //console.log(values);

        this.okService.put("monitors/"+this.id,values)
        .subscribe({
          next: (data) => {

            this.monitor = data.body;

            //console.log("monitor",this.monitor);

            this.setForm();

            this.okService.setAlert(this.transloco.translate("The monitor password has been updated"),"success");
            this.passSubmitted = false;
            this.password_error = false;
          },
          error: (e) => {

            //console.log("error",e);

            if(Array.isArray(e)){
              let self = this;
              // Use of _.forEach() method
              _.forEach(e, function(error:any) {
                //console.log(error);
                self.passFormGroup.get(error.field)?.setErrors({ invalid: error.message });
              });
            }else{
              this.okService.setAlert(e,"warning")
            }


          },
          complete: () => {
            //console.info('complete');
          }
      });


      }

    return false;
  }

  submitTeamsUrl(){
    this.teamsUrlSubmitted = true;
    this.teams_error = false;
    if(this.teamsUrlGroup.valid){
      let values = this.teamsUrlGroup.value;

      this.okService.put("monitors/"+this.id,values)
      .subscribe({
        next: (data) => {

          this.monitor = data.body;

          this.setForm();
          this.okService.setAlert(this.transloco.translate("The monitor's Teams Channel Webhook has been updated"),"success");
          this.teamsUrlSubmitted = false;
          this.teams_error = false;
        },
        error: (e) => {

          if(Array.isArray(e)){
            let self = this;
            _.forEach(e, function(error:any){
              self.teamsUrlGroup.get(error.field)?.setErrors({
                invalid: error.message 
              });
            });
          }else{
            this.okService.setAlert(e,"warning")
          }

        },
          complete: () => {
            //console.info('complete');
          }
      });
    }
  }

  doDelete(){
    if(confirm(this.transloco.translate("Are you sure you want to delete ")+this.monitor.name)) {

        this.okService.delete('monitors/'+this.monitor.id)
        .subscribe({
          next: (data) => {

            this.okService.setAlert(this.transloco.translate("We have deleted this monitor for you"),"success");
            this.router.navigateByUrl('/mgmt/monitors/monitors');

          },
          error: (e) => {

            //console.log(e);
            this.okService.setAlert(e,"warning");


          },
          complete: () => {
            //console.info('complete');
          }
      });


    }
  }

  sendWelcome(){

    this.okService.post("monitors/welcome/"+this.monitor.id,{})
    .subscribe((data) => {

      this.okService.setAlert(this.transloco.translate("The monitor welcome email has been sent"),"success");

    });
  }

  cellConditionalRequiredValidator(formControl: AbstractControl){

    let cellControl: any;
    cellControl = formControl;
    if(!cellControl.parent){
      return null;
    }

    if(cellControl.parent.get('use_sms').value || cellControl.parent.get('use_whatsapp').value){
      return Validators.required(cellControl);
    }

    return null;

  }

  callConditionalRequiredValidator(formControl: AbstractControl){

    let callControl: any;
    callControl = formControl;
    if(!callControl.parent){
      return null;
    }

    if(callControl.parent.get('use_phone').value){
      return Validators.required(callControl);
    }

    return null;

  }

}
